module.exports = __webpack_public_path__ + "m4.png";